/* eslint camelcase: "off"*/
import jwt_decode from 'jwt-decode';

export default {

  decode(token) {
    try {
      const decoded = jwt_decode(token);
      return decoded.user;
    } catch (err) {
      throw new Error(err);
    }
  },

  verify(token) {
    try {
      const decoded = jwt_decode(token);
      const time = Math.round(new Date()
        .getTime() / 1000);

      return time < decoded.exp;
    } catch (err) {
      return false;
    }
  },

};



// WEBPACK FOOTER //
// ./src/modules/getjwtdata.js